import React from 'react';

function Events() {
    return (
        <div className="container text-center">
            <h1>Events</h1>
        </div>
    )
}

export default Events;
